<!--
 * @Author: shiao
 * @Date: 2020-12-25 10:28:08
 * @LastEditTime: 2021-02-01 19:34:48
 * @Description: 酒店详情
 * @LastEditors: shiao
 * @FilePath: \o2o-appd:\gongsi\h5-hotel\h5\src\pages\hotel\detail\detail.vue
-->
<template>
  <div :class="detailbodyClass" ref="detailScrollbody">
    <!-- :class="{ isiOSX: isiOSX }" -->
    <div>
      <div class="datail-nav" :style="{ background: scrollopacity}">
        <navbar :lefticon="returnwhiteicon" :righttwoicon="clollectStatus ? collectgrayredicon : collectwhiteicon"
          :righticon="sharegrayicon" :lefticonshow="!shareStatus" :righttwoiconshow="!shareStatus"
          :righticonshow="!shareStatus" v-show="navshow" @righttwoclick="hotelToCollection" @rightclick="toShareHotel"
          @goback="goback" />
        <div v-show="!navshow">
          <div class="white-nav">
            <div class="return-black" @click="goback" v-show="!shareStatus">
              <img :src="returnblackicon" alt="" />
            </div>
            <div class="nav-room-name">{{ hotelinfo.chinese_name }}</div>
            <div class="collect-black" @click="hotelToCollection" v-show="!shareStatus">
              <img :src="clollectStatus ? collectredicon : collectblackicon" alt="" />
              <div class="collect-text">{{clollectStatus ? '已收藏' : '收藏'}}</div>
            </div>
            <div class="share-black" @click="toShareHotel" v-show="!shareStatus">
              <img :src="shareblackicon" alt="" />
              <div class="share-text">分享</div>
            </div>
          </div>
          <div class="booking-details">
            <div :class="bookactiavte ? 'booking-actiavte' : 'booking-btn'" @click="changemoduleposition('酒店预订')">
              酒店预订
            </div>
            <div :class="!bookactiavte ? 'booking-actiavte' : 'book-details-btn'" @click="changemoduleposition('酒店详情')">
              酒店详情
            </div>
          </div>
        </div>
      </div>
      <div class="bg-div" @click="golookimg">
        <van-swipe :autoplay="0" :height="240" :initial-swipe="0" :loop="false" @change="topOnChange">
          <van-swipe-item v-for="(image, index) in images" :key="index">
            <img v-lazy="image" />
          </van-swipe-item>
          <template slot="indicator">
            <div class="swipe-top-index">
              {{ images.length > 0 ? topCurrent * 1 + 1 : 0 }}/{{
                images.length - 1 > 0 ? images.length - 1 : 0
              }}
            </div>
          </template>
        </van-swipe>
      </div>
      <div class="datail-left" ref="datail_left">
        <div class="bg-two"></div>
        <div class="detail-info">
          <skeletoninfo v-show="!hotelinfo.chinese_name" />
          <div v-show="hotelinfo.chinese_name">
            <div @click="godetailinfo(1)">
              <div class="hotel-detail-title">{{ hotelinfo.chinese_name }}</div>
              <div class="hotel-tag-div">
                <div class="static-tag">{{ hotelinfo.starName }}</div>
                <div class="more-color-tag">
                  <div :class="tagColorList[index % 4]"
                    v-for="(item, index) in hotelinfo.label? hotelinfo.label.split(','): []" :key="index">
                    {{ item }}
                  </div>
                </div>
              </div>
              <div class="three-div">
                <div class="info-text">
                  {{
                  hotelinfo.openYear ? hotelinfo.openYear.split("-")[0] : ""
                }}年开业
                </div>
                <!-- <div class="info-text">2020年装修</div> -->
                <div class="info-div-right">
                  <div class="top-right-icon">
                    <span><img :src="rightblackicontop" alt="" /></span>
                  </div>
                  <div class="info-text">设施/详情</div>
                </div>
              </div>
            </div>
            <div class="four-div">
              <div class="detail-score">
                {{ hotelinfo.ratings ? hotelinfo.ratings.toFixed(1) : "0.0" }}
              </div>
              <div class="datail-description"></div>
            </div>
            <div class="five-div" @click="goposition">
              <div class="detail-address">{{ hotelinfo.address }}</div>
              <div class="detailed-distance">
                距您{{ unitConvert(distance)
              }}<span v-show="hotelinfo.business_district">,</span>
                {{ hotelinfo.business_district }}
              </div>
              <div class="detail-position">
                <img :src="positiongreenicon" alt="" />
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="fixmargin-top"></div>
      <skeletonhotelroom v-show="hotelroomlist.length == 0 && !getRoomStatus" />
      <noRoom v-show="hotelallroomlist.length == 0 && getRoomStatus" />
      <div class="room-info" v-show="hotelroomlist.length != 0 || getRoomStatus">
        <div class="time-select" :style="timeSelectStyle" v-show="hotelallroomlist.length > 0">
          <div class="time-select-div">
            <div @click.stop="gocheckin('1')">
              <div class="static-enter">入</div>
              <div class="time-div">
                {{ timeformat[0] }}
              </div>
              <div class="day-div">{{ ckeckinInfo.roomday }}晚</div>
              <div class="static-enter">离</div>
              <div class="time-div">{{ timeformat[1] }}</div>
            </div>
            <div class="time-con-right" @click.stop="gocheckin('0')">
              <div class="adult-div" :style="adultchildFontsize">{{ ckeckinInfo.adultNum }}成人</div>
              <div :class="ckeckinInfo.childNum > 0 ? 'child-black-div' : 'child-div'" :style="adultchildFontsize">
                {{ ckeckinInfo.childNum }}儿童
              </div>
              <div class="time-right-icon">
                <img :src="rightblackicontime" alt="" />
              </div>
            </div>
          </div>
          <div class="room-div">
            <div :class="roomTageIndex.includes(index)? 'room-tag-actiavte room-tag': 'room-tag'"
              v-for="(item, index) in roomTages" :key="index" @click.stop="chooseRoomTag(item, index)">
              {{ item }}
              <span v-show="roomTageIndex.includes(index)" class="close-room-tag"><img :src="tagwhitecloseicon"
                  alt=""></span>
              <!-- @click.stop="closeRoomTag(item, index)" -->
            </div>
          </div>
        </div>
        <div class="no-hotel-find" v-show="roomNofindstatus">
          <img :src="nofindhotel" alt="" />
          <div class="no-find-text">
            没有同时满足所有条件的房间了
            去掉一个筛选条件试试～
          </div>
        </div>
        <div class="recommend-room" v-show="recommendInfo.roomTypeName && !roomNofindstatus && recommendStatus"
          @click="prewivethisRoom(recommendInfo)">
          <div class="recommend-room-top">
            <div class="recommend-room-top-left">
              <div class="recommend-icon">
                <img :src="recommendwhiteicon" alt="" />
              </div>
              <div class="recommend-text">为你推荐</div>
            </div>
            <div class="recommend-room-top-right">来自携程</div>
          </div>
          <div class="recommend-bottom">
            <div class="bottom-left">
              <img :src="recommendInfo.roomTypeNames? recommendInfo.roomTypeNames[0].pictures[0]['URL']: ''" alt="" />
              <span v-show="recommendInfo.roomTypeNames"
                class="left-img-num">{{ recommendInfo.roomTypeNames ? recommendInfo.roomTypeNames[0].pictures.length : 0}}图</span>
            </div>
            <div class="bottom-right">
              <div class="bottom-right-title">
                <div class="romm-type">
                  {{recommendInfo.roomTypeNames ? recommendInfo.roomTypeNames[0].roomTypeName: ""}}
                </div>
                <div class="recommend-room-price">
                  <div class="room-price">
                    <div class="room-price-red">
                      <span>¥</span><span class="room-price-number">{{
                        recommendInfo.roomTypeNames
                          ? recommendInfo.roomTypeNames[0].raisePrice
                          : 0
                      }}</span>
                    </div>
                    <div class="room-price-text">/晚</div>
                  </div>
                </div>
              </div>
              <div class="second-div">
                <div class="second-text">
                  {{
                    recommendInfo.roomTypeNames
                      ? recommendInfo.roomTypeNames[0].labelBedName
                      : ""
                  }}
                  可住{{
                    recommendInfo.roomTypeNames
                      ? recommendInfo.roomTypeNames[0].maxOccupancy
                      : ""
                  }}人
                </div>
                <div class="second-right">
                  赠{{
                    recommendInfo.roomTypeNames
                      ? recommendInfo.roomTypeNames[0].credits
                      : 0
                  }}积分
                </div>
              </div>
              <div :class="noroomstatus ? 'no-room-text' : ''">
                <div class="three-tag-green">
                  {{
                    recommendInfo.roomTypeNames
                      ? recommendInfo.roomTypeNames[0].cancelPolicy
                      : ""
                  }}
                </div>
                <!-- <div class="three-tag-green">立即取消</div>
                <div class="three-tag-static">须担保</div> -->
              </div>
              <div class="four-btn" @click.stop="goconfirmorder(recommendInfo)">
                <div class="four-big-text">马上订</div>
                <div class="four-static-text">在线付</div>
              </div>
            </div>
          </div>
        </div>
        <div class="suggest-div" v-show="roomNofindstatus">
          以下是不符合筛选条件的房型
        </div>
        <div class="room-static-div">
          <div class="room-static" v-for="(item, i) in hotelroomlist" :key="i">
            <div class="recommend-bottom static-recommend-bottom">
              <div class="bottom-left">
                <img :src="item.roomTypeNames ? item.roomTypeNames[0].pictures[0]['URL'] : ''" alt=""
                  @click="prewivethisRoom(item)" />
                <span v-show="item.roomTypeNames"
                  class="left-img-num">{{ item.roomTypeNames ? item.roomTypeNames[0].pictures.length : 0}}图</span>
              </div>
              <div class="bottom-right" @click="showThisRoom(i)">
                <div class="bottom-right-title static-room-title">
                  <div class="romm-type">{{ item.roomTypeName }}</div>
                </div>
                <div class="room-close-btn-right" v-show="roomopenshow && roomshowNum == i">
                  <div class="room-close-price-text-img">
                    收起<img :src="closeupblackicon" alt="" />
                  </div>
                </div>
                <div class="second-div">
                  <div class="second-text-text">1个供应商提供{{item.roomTypeNames.length}}个可订价格</div>
                </div>
                <div class="price-integral-div-room" v-show="roomshowNum != i">
                  <div class="room-price-div">
                    <div class="room-price-red">
                      <span>¥</span><span class="room-price-number">{{
                        item.roomTypeNames[0].raisePrice
                      }}</span>
                    </div>
                    <div class="room-price-text-img">
                      起<img :src="openbottomblackicon" alt="" />
                    </div>
                  </div>
                  <div class="integral-div">
                    赠{{ item.roomTypeNames[0].credits }}积分
                  </div>
                </div>
                <!-- <div class="no-this-room" v-show="noroomstatus">
                <img :src="noroomicon" alt="" />
              </div> -->
              </div>
            </div>
            <div v-show="roomopenshow && i == roomshowNum" @click.stop="prewivethisRoom(item)">
              <div class="room-open" v-for="(roomchanel, cindex) in item.roomTypeNames" :key="cindex">
                <div class="room-open-title">
                  <div class="romm-detailed-title">
                    <img :src="xiechenglogo" alt="" />
                    <span>{{roomchanel.channel_name}}</span>
                  </div>
                </div>
                <div class="second-div">
                  <div class="second-text">
                    {{ roomchanel.roomBedName }} 可住{{roomchanel.maxOccupancy}}人 {{ roomchanel.mealBreakFast }}
                  </div>
                </div>
                <div>
                  <div class="three-tag-green">
                    {{ roomchanel.cancelPolicy }}
                  </div>
                  <!-- <div class="three-tag-static">须担保</div> -->
                </div>
                <div class="four-btn" @click.stop="goconfirmorder(item)">
                  <div class="four-big-text">马上订</div>
                  <div class="four-static-text">在线付</div>
                </div>
                <div class="room-price-integral">
                  <div class="room-price-integral-div">
                    <div class="room-price-red">
                      <span>¥</span><span class="room-price-number">{{
                        roomchanel.raisePrice
                      }}</span>
                    </div>
                    <div class="room-price-text">/晚</div>
                  </div>
                  <div class="second-right">赠{{ roomchanel.credits }}积分</div>
                </div>
                <!-- <div class="no-this-room">
                <img :src="noroomicon" alt="" />
              </div> -->
              </div>
            </div>
          </div>
          <div class="room-static-bottom" ref="roomstaticbottomScrollTop" @click="openAllRoom" v-show="
              this.hotelallShowroomlist.length - this.hotelroomlist.length > 0
            ">
            展开剩余{{
              this.hotelallShowroomlist.length - this.hotelroomlist.length
            }}个房型<span class="room-static-bottom-open-img"><img :src="openbottomblackicon" alt="" /></span>
          </div>
          <div class="room-static-up-bottom" @click="CloseSomeRoom" v-show="
              this.hotelallShowroomlist.length == this.hotelroomlist.length &&
              this.hotelroomlist.length != 0 &&
              this.hotelroomlist.length > 4
            ">
            收起<span class="room-static-up-bottom-img"><img :src="openbottomblackicon" alt="" /></span>
          </div>
        </div>
        <div class="datail-bottom" ref="datail_bottom">
          <div class="room-read" :style="{ 'padding-bottom': !hotelinfo.mustRead ? '2rem' : '0' }">
            <img :src="readwarningicon" alt="" />订房必读
          </div>
          <div class="read-text second-read" v-for="(item, index) in hotelinfo.mustRead" :key="index">
            {{ item.Text }}
          </div>
          <div @click="godetailinfo(2)">
            <div class="room-read" style="margin-top:3rem;">
              入住政策
              <div class="deail-right-text">
                更多详情<span class="deail-right-text-img"><img :src="rightblackiconbottom" alt="" /></span>
              </div>
            </div>
            <div class="check-in-out">
              <div>
                <div>入住</div>
                <div class="read-div-text">{{ hotelinfo.checkintime }}</div>
              </div>
              <div>
                <div>离店</div>
                <div v-html="hotelinfo.checkouttime"></div>
              </div>
            </div>
          </div>
          <div @click="godetailinfo(3)">
            <div class="room-read">
              酒店设施
              <div class="deail-right-text">
                更多详情<span class="deail-right-text-img"><img :src="rightblackiconbottom" alt="" /></span>
              </div>
            </div>
            <div class="room-detail-bottom-read-div">
              <div>
                <div class="read-div-text" v-for="(item, index) in computedfacilities[0]" :key="index">
                  {{ item.Text }}
                </div>
              </div>
              <div>
                <div class="read-div-text" v-for="(item, index) in computedfacilities[1]" :key="index">
                  {{ item.Text }}
                </div>
              </div>
            </div>
          </div>
          <div class="room-read may-like">猜你喜欢</div>
          <div class="may-list-product-list">
            <productlist v-for="(item, index) in maylikeHotelList" :key="index" :setData="item" @toggle="godetail" />
          </div>
        </div>
      </div>
      <!-- 弹窗部分 -->
      <van-popup v-model="hoteldatailshow" round position="bottom" closeable :style="{ height: '80%' }"
        @close="closehotel">
        <div class="detail-pup">
          <div class="first-title">预订须知</div>
          <div class="hotel-pup-content">
            <div class="detail-swipe-div">
              <van-swipe :autoplay="0" :height="180" @change="pupOnChange" :initial-swipe="pupInitialswipe">
                <!-- {{puproominfo.roomTypeNames[0].pictures}} -->
                <van-swipe-item v-for="(image, index) in puproominfo.roomTypeNames
                  ? puproominfo.roomTypeNames[0].pictures
                  : ['URL']" :key="index" @click="startPrewive(index)"><img v-lazy="image['URL']" />
                </van-swipe-item>
                <template slot="indicator">
                  <div class="pup-swipe-index">
                    {{ (puproominfo.roomTypeNames ? puproominfo.roomTypeNames[0].pictures : []).length > 0 ? pupCurrent * 1 + 1 : 0 }}
                    /
                    {{ (puproominfo.roomTypeNames? puproominfo.roomTypeNames[0].pictures : []).length }}
                  </div>
                </template>
              </van-swipe>
            </div>
            <div class="second-title">{{ puproominfo.roomTypeName }}</div>
            <div class="pup-second-text">
              {{ puproominfo.roomTypeName ? puproominfo.roomTypeNames[0].labelBedName : "" }}
              {{ puproominfo.roomTypeName ? puproominfo.roomTypeNames[0].bedName : "" }}
            </div>
            <div class="pup-datail-facilitys">
              <div class="facilitys-div">
                <div
                  v-for="(item, i) in computedRoomfacilities(puproominfo.roomTypeNames? puproominfo.roomTypeNames[0].facilityItem: [])[0]"
                  :key="i">
                  {{ item }}
                </div>
              </div>
              <div class="facilitys-div">
                <div
                  v-for="(item, i) in computedRoomfacilities(puproominfo.roomTypeNames ? puproominfo.roomTypeNames[0].facilityItem: [] )[1]"
                  :key="i">
                  {{ item }}
                </div>
              </div>
              <div class="facilitys-div">
                <div
                  v-for="(item, i) in computedRoomfacilities(puproominfo.roomTypeNames ? puproominfo.roomTypeNames[0].facilityItem : [] )[2]"
                  :key="i">
                  {{ item }}
                </div>
                <div @click="roomfacilitiesList = roomfacilitiesAllList"
                  v-show="roomfacilitiesList.length != roomfacilitiesAllList.length">
                  展开全部设施<img :src="openbottomblackicon" alt="" />
                </div>
              </div>
            </div>
            <div class="second-title">必读须知</div>
            <div class="food-tip">餐食：{{ puproominfo.breakFast }}</div>
            <div class="tip-text" v-show="puproominfo.cancelPolicy == '不可取消'">
              订单一经支付不可取消或修改，如未按照订单入住或取消，
              已经预付的费用将无法退还。
            </div>
            <div class="three-title" v-show="puproominfo.cancelPolicy != '不可取消'"> 取消规则</div>
            <div class="tip-text">
              {{ puproominfo.description }}
            </div>
          </div>
        </div>
        <div class="pup-datail-bottom">
          <div class="pup-datail-price">
            <div class="room-price">
              <div class="room-price-red">
                <span>¥</span>
                <span
                  class="room-price-number">{{ puproominfo.roomTypeName ? puproominfo.roomTypeNames[0].raisePrice : "" }}</span>
              </div>
              <div class="room-price-text">/晚</div>
            </div>
          </div>
          <div class="pup-booking-btn" @click="goconfirmorder(puproominfo)">马上预订</div>
        </div>
      </van-popup>
    </div>
    <imagepreview :previewshow="previewshow" :previewimages="puproomImages" :prewivewIndex="prewivewIndex"
      @closeImagePreview="closeImagePreview" />
    <networkerror v-show="networkerror" />
    <van-popup :overlay-style="{'background-color':'rgba(0,0,0,0.5)'}" :style="{'border-radius': '1rem'}" :close-on-click-overlay="false" v-model="downhotelshow">
      <div class="pop-position">
        <h3>温馨提示</h3>
        <p>该酒店已下架，请选择其他酒店。</p>
        <div>
          <div @click="goback">知道了</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import navbar from "../components/nav-bar.vue";
  import networkerror from "../components/networkerror.vue";
  import skeletonhotelroom from "./components/skeleton-hotelroom.vue";
  import skeletoninfo from "./components/skeleton-hotelinfo.vue";
  import productlist from "../components/product-list.vue";
  import imagepreview from "../components/image-preview.vue";
  import noRoom from "../components/no-room.vue";
  import commonfunction from "../api/publiccommon";
  import {
    Toast
  } from "vant";
  import {
    getHotelDetail,
    getHotelRoom,
    getHotelGuess,
    getHotelCheckRoom,
    hotelAddCollection,
    hotelCancelCollection,
    getShareHotelDetail,
    getShareHotelRoom,
    getShareHotelGuess,
  } from "../api/index.js";
  import {
    mapState,
    mapMutations
  } from "vuex";
  export default {
    components: {
      navbar,
      networkerror,
      skeletonhotelroom,
      skeletoninfo,
      productlist,
      noRoom,
      imagepreview
    },
    data() {
      return {
        returnblackicon: require("@/assets/hotel/img/micon/return-black-icon.png"),
        returnwhiteicon: require("@/assets/hotel/img/detail/return-gray-icon.png"),
        readwarningicon: require("@/assets/hotel/img/micon/read-warning-icon.png"),
        recommendwhiteicon: require("@/assets/hotel/img/micon/recommend-white-icon.png"),
        rightblackicontime: require("@/assets/hotel/img/detail/right-black-icon-time.png"),
        rightblackicontop: require("@/assets/hotel/img/detail/right-black-icon-top.png"),
        rightblackiconbottom: require("@/assets/hotel/img/detail/right-black-icon-bottom.png"),
        collectwhiteicon: require("@/assets/hotel/img/micon/collect-white-icon.png"),
        collectgrayredicon: require("@/assets/hotel/img/detail/collect-gray-red-icon.png"),
        collectredicon: require("@/assets/hotel/img/detail/collect-red-icon.png"),
        collectblackicon: require("@/assets/hotel/img/detail/collect-black-icon.png"),
        closeupblackicon: require("@/assets/hotel/img/micon/close-up-black-icon.png"),
        shareblackicon: require("@/assets/hotel/img/detail/share-black-icon.png"),
        sharegrayicon: require("@/assets/hotel/img/detail/share-gray-icon.png"),
        nofindhotel: require("@/assets/hotel/img/micon/no-find-hotel.png"),
        noroomicon: require("@/assets/hotel/img/micon/no-room-icon.png"),
        openbottomblackicon: require("@/assets/hotel/img/micon/open-bottom-black-icon.png"),
        positiongreenicon: require("@/assets/hotel/img/micon/position-green-icon.png"),
        xiechenglogo: require("@/assets/hotel/img/micon/xiecheng-logo.png"),
        lookmore: require("@/assets/hotel/img/detail/hotel-detail-white-bg.png"),
        tagwhitecloseicon: require("@/assets/hotel/img/detail/tag-white-close-icon.png"),
        images: [], //顶部轮播背景
        isiOSX: false,
        roomopenshow: false, //酒店房间是否展开
        roomshowNum: -1, //房间展开的第几个
        pagetopFixed: false,
        scrollopacity: 0,
        bookshow: true,
        noroomstatus: false, //没有房间
        hoteldatailshow: false, //酒店详情是否展开
        navshow: true, //标题的切换
        datail_leftTop: 0, //酒店预订模块位置
        datail_bottomTop: 0,
        bookactiavte: true, //切换模块高亮第几个
        hotelinfo: {
          facilities: [],
          checkintime: "",
          checkouttime: "",
        },
        hotelallShowroomlist: [], //可以展示的所有房间列表
        hotelallCloseroomlist: [], //需要折叠隐藏的房间列表
        hotelroomlist: [], //部分酒店房间列表
        getRoomStatus: false, //是否接口获取酒店
        hotelallroomlist: [], //所有酒店房间列表
        findroomlist: [], //本地搜索满足条件的房间列表
        networkerror: false, //是否网络错误
        puproominfo: {}, //弹窗酒店信息
        nowCoin: 0, //威币
        roomTages: ["大床房", "双床房", "免费取消", "立即确认"],
        roomTageIndex: [-1], //房间类型选择索引
        roomTageNameList: [], //房间类型选择名称数组
        roomNofindstatus: false, //房间筛选没有找到合适的房型
        hotel_id: "", //酒店id
        maylikeHotelList: [], //可能喜欢的酒店列表
        longitude: "", //经度
        latitude: "", //纬度
        clollectStatus: false, //收藏的状态
        distance: "", //距离
        topCurrent: 0,
        pupCurrent: 0, //房间详情弹窗的图片轮播索引
        pupInitialswipe: 0, //房间详情弹窗的图片轮播索引起始位置
        transport: "", //酒店可乘交通工具信息
        recommendInfo: {}, //推荐酒店信息
        is_remark: "", //比例
        shareStatus: false, //分享进入
        sharelogo: "", //分享的主图
        formConfirmorder: false, //是否是从订单页面回来
        tagColorList: [
          "static-tag-green",
          "static-tag-yellow",
          "static-tag-red",
          "static-tag-blue",
        ], //标签的颜色
        timeSelectStyle: {
          position: "sticky",
          top: "11.9rem",
        }, //时间选择等的动态样式
        roomfacilitiesList: [], //酒店的房间设施前8个
        roomfacilitiesAllList: [], //酒店的房间设施
        roomstaticbottomScrollTop: 0, //房间点击展开的位置
        puproomImages: [], //酒店房间图片
        prewivewIndex: 0, //图片预览的起始位置
        previewshow: false, //预览图片是否显示
        recommendStatus: false, //为你推荐的酒店是否显示
        detailbodyClass: 'detail-body',
        initStatus: false, //是否执行init方法进行初始化
        downhotelshow: false,
      };
    },
    watch: {
      // 监听相同路由下参数变化的时候，从而实现异步刷新----只有路由发生变化时
      $route(to, from) {
        if (
          from.path == "/hotel/detailinfo" ||
          from.path == "/hotel/position" ||
          from.path == "/hotel/checkin" ||
          from.path == "/hotel/confirmorder"
        ) {
          sessionStorage.setItem("routeReadyload", "false");
          if (from.path != "/hotel/position" && from.path != "/hotel/checkin") {
            sessionStorage.setItem("hotelDetailBodyAnimate", "true");
          }
        } else {
          sessionStorage.setItem("routeReadyload", "true"); //路由调用初始化
          sessionStorage.setItem("hotelDetailBodyAnimate", "false");
          if (from.path == "/hotel/detail" && to.path == "/hotel/detail") {
            if (!this.$route.query.share) {
              this.init();
            } else {
              this.shareInit();
            }
          }
        }
      },
    },
    beforeRouteEnter(to, from, next) {
      if (from.path == "/hotel/confirmorder") {
        sessionStorage.setItem("hoteldatailrealyshow", "true");
      }
      next();
    },
    //路由离开
    beforeRouteLeave(to, from, next) {
      sessionStorage.setItem("hoteldatailrealyshow", "false");
      if (to.path != "/hotel/confirmorder" && to.path != "/hotel/detailinfo") {
        this.setState([{
          name: 'hoteldetail',
          value: {
            hotelinfo: this.hoteldetail.hotelinfo,
            'roominfo': {},
            canTakeTaxi: this.hoteldetail.canTakeTaxi
          }
        }])
      }
      if (to.path == "/hotel/detailinfo" || to.path == "/hotel/position" || to.path == "/hotel/checkin" || to.path ==
        "/hotel/confirmorder"
      ) {
        sessionStorage.setItem("routeReadyload", "false");
      } else {
        sessionStorage.setItem("routeReadyload", "true"); //路由调用初始化
      }
      next();
    },
    computed: {
      ...mapState({
        ckeckinInfo: (state) => state.hotel.ckeckinInfo,
        hoteldetail: (state) => state.hotel.hoteldetail,
        searchCity: (state) => state.hotel.searchCity,
      }),
      computedfacilities() {
        let onelist = [];
        let twolist = [];
        for (let i in this.hotelinfo.facilities.slice(0, 6)) {
          if (i % 2 == 0) {
            onelist.push(this.hotelinfo.facilities[i]);
          } else {
            twolist.push(this.hotelinfo.facilities[i]);
          }
        }
        return [onelist, twolist];
      },
      //日期转换
      timeformat() {
        let start_timelist = this.ckeckinInfo.start_time.split("-");
        let end_timelist = this.ckeckinInfo.end_time.split("-");
        return [
          start_timelist[1] + "月" + start_timelist[2] + "日",
          end_timelist[1] + "月" + end_timelist[2] + "日",
        ];
      },
      adultchildFontsize() {
        if (this.ckeckinInfo.adultNum >= 10 && this.ckeckinInfo.childNum >= 10) {
          return {
            'font-size': '1.5rem'
          }
        } else {
          return {
            'font-size': '1.6rem'
          }
        }
      },
    },
    //从其他页面返回时，也会触发此方法,生命周期相当于created
    activated() {
      this.downhotelshow = false
      this.navshow = true;
      this.prewivewIndex = 0;
      this.pupInitialswipe = 0;
      this.pupCurrent = 0;
      this.topCurrent = 0;
      this.puproomImages = []
      this.maylikeHotelList = []
      this.scrollopacity = `rgba(255, 255, 255,0)`;
      // this.recommendStatus = false;
      this.roomTageIndex = [-1]; //房间类型选择索引
      this.roomTageNameList = []; //房间类型选择名称数组
      this.roomNofindstatus = false
      // localStorage.setItem('_token','Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImUyNzAxMzY5YjQ0NDkwMjM5MjUzZmY4ZDVjNTRkZTViMDAxYTBiMjIwZDIxZWQ3NTE5MmExYmYxM2VlNGMwZGYxZjk5MTZiMGZlYWJjOTA4In0.eyJhdWQiOiI0IiwianRpIjoiZTI3MDEzNjliNDQ0OTAyMzkyNTNmZjhkNWM1NGRlNWIwMDFhMGIyMjBkMjFlZDc1MTkyYTFiZjEzZWU0YzBkZjFmOTkxNmIwZmVhYmM5MDgiLCJpYXQiOjE2MDk4MTI3NDcsIm5iZiI6MTYwOTgxMjc0NywiZXhwIjoxNjQxMzQ4NzQ3LCJzdWIiOiIyMDA1MTE3Iiwic2NvcGVzIjpbXSwiaXNzIjoibWVtYmVyIn0.IrjGoBYZaJckAoRjg_xvP9VbT5FIZTRBpZkz49RM_pWyg11RkzcxNCVoas2k35I-dIa1TGaTr9ZRNpCx4LLKIXG8WGdRw-9g8NRYk1HnSn1ZuoKNVpsI6QdR1kJ8wpuVcD5vUcJYrDHrBVjqcaDNptQ_TRN6aXCprmWIaQC7woFosQYvcxbNweCfn-EB6jwJXHjulFakRVlwch53dUmpitbGOP216iiOatvUW04NN1U-icpRkQye6j4OjU67EJMiq16hjLcPAM9lI1ialcjQ3w0T8K4eUw6S4AYcDDdHfifz2Cg4EYETl3JUmsxNtzK3tJ340HKt1kWhBOUrqOZld1dkr8lFDd3NaA1n964u9K7cyeWNkMlNNVE48PKTp1O9d3QW0rRw5kCuOzjjgP6vzBc3zKUMzE5B3zt6QYM9QaTuFALlSR6ca8ZhKPhNwboxjX3B5xH8QMNOJ5xHe5yiibZeNhWiAUTGAFbEJp70FASYrOu76-nAyBdCRNbGo6AhZ7zBq1xBmph7Se8aGR1kov6eo1H6iQo1jSRvxY5B_VPJUW0rmml63y84x3tOWCUUAprcKYq6TESIsyTWBE4Fa-jaDIR-GEIaarkSj1cuOVp7vzNkv6w-NMl4BoKBYoIKfFopD29ceUU_2fjsh-ZNsfy0e3taL7k32AFu_cnGK7A')
      this.$set(this.ckeckinInfo, "start_timeWeek", this.formatDate(this.ckeckinInfo.start_timeDate)[1]);
      this.$set(this.ckeckinInfo, "end_timeWeek", this.formatDate(this.ckeckinInfo.end_timeDate)[1]);
      this.setState([{
        name: 'ckeckinInfo',
        value: this.ckeckinInfo
      }])
      this.shareStatus = this.$route.query.share != undefined ? true : false;
      this.hoteldatailshow = false;
      if (this.shareStatus) {
        this.shareInit();
      } else {
        if (!sessionStorage.getItem("routeReadyload")) {
          sessionStorage.setItem("routeReadyload", "true");
        }
        if (sessionStorage.getItem('hotelDetailBodyAnimate') == 'true') {
          this.$refs.detailScrollbody.scrollTop = sessionStorage.getItem('hotelDetailScroolTop') ? sessionStorage
            .getItem('hotelDetailScroolTop') : 0
        }
        setTimeout(() => { //解决页面进入时滚动事件挂载失败
          document.addEventListener("scroll", this.screenScroll, true);
          if (sessionStorage.getItem("routeReadyload") == 'true') {
            this.detailbodyClass = 'detail-body'
            this.$refs.detailScrollbody.scrollTop = 0;
          }
        }, 5);

        let backroominfo = this.hoteldetail.roominfo; //从订单回来的准备处理一下弹窗
        if (backroominfo.roomTypeNames) {
          this.images = backroominfo.images;
          this.hotel_id = this.$route.query.hotel_id;
          this.puproominfo = backroominfo;
          for (let i in this.puproominfo.roomTypeNames[0].pictures) {
            this.puproomImages.push(this.puproominfo.roomTypeNames[0].pictures[i]["URL"]);
          }
          this.hoteldatailshow = true;
          this.formConfirmorder = true;
        }
        if (sessionStorage.getItem("routeReadyload") == "true") {
          this.init();
        }
      }
    },
    mounted() {
      setTimeout(() => {
        this.$refs.detailScrollbody.scrollTop = 0;
        document.addEventListener("scroll", this.screenScroll, true);
      }, 10);
    },
    methods: {
      ...mapMutations(["setState"]),
      //初始化页面
      async init() {
        this.downhotelshow = false
        this.initStatus = true
        this.hotelinfo = {
          facilities: [],
          checkintime: "",
          checkouttime: "",
        };
        this.$refs.detailScrollbody.scrollTop = 0;
        this.navshow = true;
        this.prewivewIndex = 0;
        this.pupInitialswipe = 0;
        this.maylikeHotelList = []
        this.roomTageIndex = [-1]; //房间类型选择索引
        this.roomTageNameList = []; //房间类型选择名称数组
        this.roomNofindstatus = false
        this.pupCurrent = 0;
        this.topCurrent = 0;
        this.clollectStatus = false;
        this.topCurrent = 0;
        this.images = [];
        this.getRoomStatus = false;
        this.hotelroomlist = [];
        this.roomopenshow = false; //酒店房间是否展开
        this.roomshowNum = -1; //房间展开的第几个
        this.isiOSX = this.isIphoneX();
        this.hotel_id = this.$route.query.hotel_id;
        const coordinate = JSON.parse(sessionStorage.getItem("coordinate"));
        this.longitude = coordinate.longitude;
        this.latitude = coordinate.latitude;
        await getHotelDetail(this.hotel_id, this.longitude, this.latitude).then(
          (res) => {
            if (res.book == false) {
              this.downhotelshow = true
              return
            }
            if (res.logo) {
              // this.images.push(res.logo);
              this.sharelogo = res.logo;
            }
            let newImageList = res.pictures.official.appearance.concat(
              res.pictures.official.public_area
            );
            newImageList = newImageList.concat(res.pictures.official.other);
            for (let i in newImageList) {
              if (this.images.length == 10) {
                this.images.push(this.lookmore);
                break;
              }
              this.images.push(newImageList[i]);
              if (i == newImageList.length - 1) {
                this.images.push(this.lookmore);
              }
            }
            this.hotelinfo = res;
            this.setState([{
              name: "hoteldetail",
              value: {
                hotelinfo: this.hotelinfo,
                roominfo: {},
                canTakeTaxi: this.hoteldetail.canTakeTaxi
              },
            }]);
            this.distance = res.distance;
            //处理数据，返回一个酒店的交通方式
            for (let i in res.transport) {
              if (res.transport[i].Directions != "") {
                this.transport = "距" + res.transport[i].Name + res.transport[i].Directions;
                break;
              }
            }
            if (res.is_collected == 1) {
              this.clollectStatus = true;
            } else {
              this.clollectStatus = false;
            }
            for (let i in res.policy) {
              if (res.policy[i].code == "CheckInCheckOut") {
                let checkinlist = res.policy[i].Text.split("&nbsp;");
                this.$set(
                  this.hotelinfo,
                  "checkintime",
                  checkinlist[0].split("：")[1]
                );
                this.$set(this.hotelinfo, "checkouttime", checkinlist[checkinlist.length - 1].split("：")[1]);
              }
            }
            setTimeout(() => {
              this.datail_leftTop = this.$refs.datail_left ?
                this.$refs.datail_left.offsetTop - 122 :
                0;
            }, 1);
          }
        );
        await getHotelRoom(
          this.hotel_id,
          this.ckeckinInfo.start_timeDate,
          this.ckeckinInfo.end_timeDate
        ).then((res) => {
          this.hotelallroomlist = res.list;
          this.hotelallShowroomlist = this.hotelallroomlist;
          this.nowCoin = res.nowCoin;
          this.hotelroomlist = this.hotelallroomlist.slice(0, 4);
          this.getRoomStatus = true;
          this.recommonRoomInfo(this.hotelallroomlist);
          setTimeout(() => {
            this.datail_bottomTop = this.$refs.datail_bottom ?
              this.$refs.datail_bottom.offsetTop - 122 :
              0;
            this.roomstaticbottomScrollTop = this.$refs.roomstaticbottomScrollTop ?
              this.$refs.roomstaticbottomScrollTop.offsetTop - 260 :
              0;
          }, 1);
        }).catch(err => {
          if (err.code == 422) {
            Toast('入住时间不可早于今天')
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          }
        });
        await getHotelGuess(this.hotel_id, this.longitude, this.latitude).then((res) => {
          this.maylikeHotelList = res.list;
        });
      },
      //分享的初始化页面
      shareInit() {
        this.downhotelshow = false
        this.hotelinfo = {
          facilities: [],
          checkintime: "",
          checkouttime: "",
        };
        this.maylikeHotelList = []
        this.roomTageIndex = [-1]; //房间类型选择索引
        this.roomTageNameList = []; //房间类型选择名称数组
        this.roomNofindstatus = false
        this.clollectStatus = false;
        this.topCurrent = 0;
        this.images = [];
        this.getRoomStatus = false;
        this.hotelroomlist = [];
        this.roomopenshow = false; //酒店房间是否展开
        this.roomshowNum = -1; //房间展开的第几个
        this.isiOSX = this.isIphoneX();
        this.hotel_id = this.$route.query.hotel_id;
        this.$refs.detailScrollbody.scrollTop = 0;
        this.navshow = true;
        getShareHotelDetail(this.hotel_id).then((res) => {
          if (res.book == false) {
              this.downhotelshow = true
              return
            }
          if (res.logo) {
            this.sharelogo = res.logo;
          }
          let newImageList = res.pictures.official.appearance.concat(res.pictures.official.public_area);
          newImageList = newImageList.concat(res.pictures.official.other);
          for (let i in newImageList) {
            if (this.images.length == 10) {
              this.images.push(this.lookmore);
              break;
            } else if (i == newImageList.length - 1) {
              this.images.push(this.lookmore);
            }
            this.images.push(newImageList[i]);
          }
          this.hotelinfo = res;
          this.setState([{
            name: "hoteldetail",
            value: {
              hotelinfo: this.hotelinfo,
              roominfo: {},
              canTakeTaxi: this.hoteldetail.canTakeTaxi
            },
          }]);
          this.distance = res.distance;
          //处理数据，返回一个酒店的交通方式
          for (let i in res.transport) {
            if (res.transport[i].Directions != "") {
              this.transport = "距" + res.transport[i].Name + res.transport[i].Directions;
              break;
            }
          }
          if (res.is_collected == 1) {
            this.clollectStatus = true;
          } else {
            this.clollectStatus = false;
          }
          for (let i in res.policy) {
            if (res.policy[i].code == "CheckInCheckOut") {
              let checkinlist = res.policy[i].Text.split("&nbsp;");
              this.$set(this.hotelinfo, "checkintime", checkinlist[0].split("：")[1]);
              this.$set(this.hotelinfo, "checkouttime", checkinlist[checkinlist.length - 1].split("：")[1]);
            }
          }
          setTimeout(() => {
            this.datail_leftTop = this.$refs.datail_left ?
              this.$refs.datail_left.offsetTop - 122 :
              0;
          }, 1);
        });
        getShareHotelRoom(
          this.hotel_id,
          this.ckeckinInfo.start_timeDate,
          this.ckeckinInfo.end_timeDate
        ).then((res) => {
          this.hotelallroomlist = res.list;
          this.hotelallShowroomlist = this.hotelallroomlist;
          this.nowCoin = res.nowCoin;
          this.hotelroomlist = this.hotelallroomlist.slice(0, 4);
          this.getRoomStatus = true;
          this.recommonRoomInfo(this.hotelallroomlist);
          setTimeout(() => {
            this.datail_bottomTop = this.$refs.datail_bottom ?
              this.$refs.datail_bottom.offsetTop - 122 :
              0;
            this.roomstaticbottomScrollTop = this.$refs.roomstaticbottomScrollTop ?
              this.$refs.roomstaticbottomScrollTop.offsetTop - 260 :
              0;
          }, 1);
        });
        getShareHotelGuess(this.hotel_id).then((res) => {
          this.maylikeHotelList = res.list;
        });
      },
      //处理距离显示
      unitConvert(num) {
        return commonfunction.unitConvert(num);
      },
      //格式化处理时间
      formatDate(date) {
        const week = date.getDay();
        let str = "";
        if (week == 0) {
          str = "周日";
        } else if (week == 1) {
          str = "周一";
        } else if (week == 2) {
          str = "周二";
        } else if (week == 3) {
          str = "周三";
        } else if (week == 4) {
          str = "周四";
        } else if (week == 5) {
          str = "周五";
        } else if (week == 6) {
          str = "周六";
        }
        let time = `${
        String(date.getMonth() + 1).length == 1
          ? "0" + String(date.getMonth() + 1)
          : date.getMonth() + 1
      }.${
        String(date.getDate()).length == 1
          ? "0" + String(date.getDate())
          : date.getDate()
      } ${str}`;
        let timeweek = `${
        String(date.getMonth() + 1).length == 1
          ? "0" + String(date.getMonth() + 1)
          : date.getMonth() + 1
      }月${
        String(date.getDate()).length == 1
          ? "0" + String(date.getDate())
          : date.getDate()
      }日 ${str}`;
        return [time, timeweek];
      },
      //处理为你推荐的房间信息
      recommonRoomInfo(NowRoomList) {
        let price = NowRoomList.length > 0 ? NowRoomList[0].roomTypeNames[0].raisePrice : 0;
        let lowerPriceinfo = {};
        let lowerPriceStatus = false
        for (let i in NowRoomList) {
          if (NowRoomList[i].roomTypeNames[0].raisePrice <= price && NowRoomList[i].roomTypeNames[0].cancelPolicy ==
            '免费取消') {
            price = NowRoomList[i].roomTypeNames[0].raisePrice;
            lowerPriceinfo = NowRoomList[i];
            lowerPriceStatus = true
          } else if (NowRoomList[i].roomTypeNames[0].raisePrice <= price) {
            if (!lowerPriceStatus) {
              price = NowRoomList[i].roomTypeNames[0].raisePrice;
              lowerPriceinfo = NowRoomList[i];
            }
          }
        }
        this.recommendStatus = true;
        this.recommendInfo = lowerPriceinfo;
      },
      //处理房间设施数据
      computedRoomfacilities() {
        let onelist = [];
        let twolist = [];
        let threelist = [];
        let indexnum = 1;
        for (let i in this.roomfacilitiesList) {
          if (indexnum == 1) {
            onelist.push(this.roomfacilitiesList[i].name);
            indexnum += 1;
          } else if (indexnum == 2) {
            twolist.push(this.roomfacilitiesList[i].name);
            indexnum += 1;
          } else if (indexnum == 3) {
            threelist.push(this.roomfacilitiesList[i].name);
            indexnum = 1;
          }
        }
        return [onelist, twolist, threelist];
      },
      //页面滚动事件
      screenScroll() {
        let scrollTop = Math.ceil(this.$refs.detailScrollbody.scrollTop);
        sessionStorage.setItem('hotelDetailScroolTop', scrollTop)
        let opacity =
          scrollTop / this.datail_leftTop > 1 ?
          1 :
          scrollTop / this.datail_leftTop;
        this.scrollopacity = `rgba(255, 255, 255,${opacity})`;
        if (scrollTop >= this.datail_leftTop) {
          this.pagetopFixed = true;
          this.navshow = false;
          if (scrollTop < this.datail_bottomTop) {
            this.bookshow = true;
            this.bookactiavte = true;
            this.timeSelectStyle = {
              position: "sticky",
              top: "11.9rem",
            };
          } else if (scrollTop >= this.datail_bottomTop && this.datail_bottomTop != 0) {
            this.timeSelectStyle = {
              position: "relative",
              top: "-2.0rem",
            };
            this.bookshow = true;
            this.bookactiavte = false;
          } else {
            this.bookshow = false;
          }
        } else {
          this.pagetopFixed = false;
          this.bookshow = false;
          this.navshow = true;
        }
      },
      //切换酒店详情按钮
      changemoduleposition(position) {
        if (position === "酒店预订") {
          this.$refs.detailScrollbody.scrollTop = this.datail_leftTop;
          this.bookactiavte = true;
          this.timeSelectStyle = {
            position: "sticky",
            top: "11.9rem",
          };
        } else if (position === "酒店详情") {
          this.timeSelectStyle = {
            position: "relative",
            top: "-2.0rem",
          };
          this.bookactiavte = false;
          this.$refs.detailScrollbody.scrollTop = this.datail_bottomTop;
        }
      },
      //选中要筛选的标签,筛选房间
      chooseRoomTag(name, num = "num") {
        if (this.roomTageIndex.includes(num) && this.roomTageNameList.includes(name)) {
          this.roomopenshow = false; //酒店房间是否展开
          this.roomshowNum = -1; //房间展开的第几个
          this.roomTageNameList.splice(this.roomTageNameList.indexOf(name), 1);
          this.roomTageIndex.splice(this.roomTageIndex.indexOf(num), 1);
          this.chooseRoomTag('')
          if (this.roomTageIndex.length == 1) {
            this.roomNofindstatus = false;
            this.hotelroomlist = this.hotelallroomlist.slice(0, 4);
            this.hotelallShowroomlist = this.hotelallroomlist;
            if (this.roomTageNameList.length == 0) {
              this.recommendStatus = true;
            }
            for (let roonName of this.roomTageNameList) {
              if (
                roonName.includes(this.recommendInfo.roomTypeNames[0].roomBedName)
              ) {
                this.recommendStatus = true;
              } else if (
                roonName == this.recommendInfo.roomTypeNames[0].cancelPolicy
              ) {
                this.recommendStatus = true;
              } else {
                this.recommendStatus = false;
              }
            }
            // this.recommonRoomInfo(this.hotelallShowroomlist);
          }
        } else {
          this.roomopenshow = false; //酒店房间是否展开
          this.roomshowNum = -1; //房间展开的第几个
          this.findroomlist = [];
          if (num != "num" && !this.roomTageIndex.includes(num)) {
            this.roomTageIndex.push(num);
          }
          if (!this.roomTageNameList.includes(name) && name != "") {
            this.roomTageNameList.push(name);
            if (this.roomTageNameList.includes('大床房') && name == '双床房') {
              // this.roomTageNameList.splice(this.roomTageNameList.indexOf('大床房'),1)
              this.closeRoomTag('大床房', 0)
            } else if (this.roomTageNameList.includes('双床房') && name == '大床房') {
              // this.roomTageNameList.splice(this.roomTageNameList.indexOf('双床房'),1)
              this.closeRoomTag('双床房', 1)
            }
          }
          const roomlist = this.hotelallroomlist;
          //只要满足一个条件就返回的功能
          //   roomlist[i].roomTypeNames[0].cancelPolicy == roonName ||
          //   roonName.includes(roomlist[i].roomTypeNames[0].roomBedName)
          // ) {
          //   this.findroomlist.push(roomlist[i]);
          // }
          if (this.findroomlist.length == 0) {
            this.findroomlist = this.hotelallroomlist;
          }
          for (let i in roomlist) {
            for (let roonName of this.roomTageNameList) {
              this.findroomlist = this.findRoomTag(
                roonName,
                roomlist[i].roomTypeNames[0]
              );
            }
          }
          if (this.findroomlist.length == 0 && this.roomTageIndex.length > 1) {
            this.roomNofindstatus = true;
            this.recommendStatus = false;
          } else {
            this.roomNofindstatus = false;
            this.hotelroomlist = this.findroomlist.slice(0, 4);
            this.hotelallShowroomlist = this.findroomlist;
            // this.recommonRoomInfo(this.hotelallShowroomlist);
          }
        }
      },
      //递归处理判断条件
      findRoomTag(tagname) {
        if (tagname == "免费取消" || tagname == "立即确认") {
          return this.findroomlist.filter((item, index, a) => {
            if (tagname == this.recommendInfo.roomTypeNames[0].cancelPolicy) {
              this.recommendStatus = true;
            } else {
              this.recommendStatus = false;
            }
            return item.roomTypeNames[0].cancelPolicy == tagname;
          });
        } else {
          return this.findroomlist.filter((item, index, a) => {
            if (
              tagname.includes(this.recommendInfo.roomTypeNames[0].roomBedName)
            ) {
              this.recommendStatus = true;
            } else {
              this.recommendStatus = false;
            }
            return tagname.includes(item.roomTypeNames[0].roomBedName);
          });
        }
      },
      //关闭选中筛选的标签
      closeRoomTag(name, num) {
        this.roomopenshow = false; //酒店房间是否展开
        this.roomshowNum = -1; //房间展开的第几个
        this.roomTageNameList.splice(this.roomTageNameList.indexOf(name), 1);
        this.chooseRoomTag("");
        this.roomTageIndex.splice(this.roomTageIndex.indexOf(num), 1);
        if (this.roomTageIndex.length == 1) {
          this.roomNofindstatus = false;
          this.hotelroomlist = this.hotelallroomlist.slice(0, 4);
          this.hotelallShowroomlist = this.hotelallroomlist;
          if (this.roomTageNameList.length == 0) {
            this.recommendStatus = true;
          }
          for (let roonName of this.roomTageNameList) {
            if (
              roonName.includes(this.recommendInfo.roomTypeNames[0].roomBedName)
            ) {
              this.recommendStatus = true;
            } else if (
              roonName == this.recommendInfo.roomTypeNames[0].cancelPolicy
            ) {
              this.recommendStatus = true;
            } else {
              this.recommendStatus = false;
            }
          }
          // this.recommonRoomInfo(this.hotelallShowroomlist);
        }
      },
      //展开所有房间
      openAllRoom() {
        this.hotelallCloseroomlist = this.hotelroomlist;
        this.hotelroomlist = this.hotelallShowroomlist;
        setTimeout(() => {
          this.datail_bottomTop = this.$refs.datail_bottom ?
            this.$refs.datail_bottom.offsetTop - 122 :
            0;
        }, 10);
      },
      //收起房间
      CloseSomeRoom() {
        this.hotelroomlist = this.hotelallCloseroomlist;
        this.$refs.detailScrollbody.scrollTop = this.roomstaticbottomScrollTop;
        setTimeout(() => {
          this.datail_bottomTop = this.$refs.datail_bottom ?
            this.$refs.datail_bottom.offsetTop - 122 :
            0;
        }, 10);
      },
      //顶部轮播索引改变
      topOnChange(index) {
        if (index == this.images.length - 1) {
          this.golookimg();
          return;
        }
        this.topCurrent = index;
      },
      //弹窗轮播索引改变
      pupOnChange(index) {
        this.pupCurrent = index;
      },
      //展示房间价格详情
      showThisRoom(index) {
        if (this.roomshowNum == index) {
          this.showThisRoom()
        } else {
          this.roomshowNum = index;
          this.roomopenshow = true;
        }
      },
      //关闭房间价格详情显示
      closeThisRoom() {
        this.roomshowNum = -1;
        this.roomopenshow = false;
      },
      //检查房间是否预订
      async checkRoom(item, doit = false) {
        let people_num =
          this.ckeckinInfo.childNum + this.ckeckinInfo.adultNum;
        let late_arrival_time = this.ckeckinInfo.start_time + " 14:00:00";
        let checkinfo = {
          checkstatus: true,
        };
        await getHotelCheckRoom(
          this.hotel_id,
          this.ckeckinInfo.start_time,
          this.ckeckinInfo.end_time,
          item.roomTypeNames[0].room_id,
          people_num,
          this.ckeckinInfo.roomNum,
          "CTrip",
          late_arrival_time
        ).then((res) => {
          this.is_remark = res.is_remark;
          if (res.message == "该房型无法预订") {
            Toast(res.message);
            checkinfo.checkstatus = false;
          } else {
            let puproominfo = Object.assign(item, res);
            this.puproomImages = []
            for (let i in puproominfo.roomTypeNames[0].pictures) {
              this.puproomImages.push(
                puproominfo.roomTypeNames[0].pictures[i]["URL"]
              );
            }
            this.$set(this, "puproominfo", puproominfo);
            checkinfo.checkstatus = true;
            checkinfo.arrivalTimeFrom = res.arrivalTimeFrom;
            checkinfo.arrivalTimeEnd = res.arrivalTimeEnd;
            if (!this.hoteldatailshow) {
              this.roomfacilitiesAllList = this.puproominfo.roomTypeNames ?
                this.puproominfo.roomTypeNames[0].facilityItem : [];
              this.roomfacilitiesList = this.roomfacilitiesAllList.slice(0, 8);
              if (doit) {
                this.hoteldatailshow = true;
              }
            }
          }
        }).catch(err => {
          if (err.code == 422) {
            Toast('入住时间不可早于今天')
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          }else if (err.code == "363") {
            Toast(err.message);
            checkinfo.checkstatus = false;
          }
        });
        return checkinfo;
      },
      //关闭酒店房间详情弹窗
      closehotel() {
        if (this.formConfirmorder) {
          this.formConfirmorder = false;
          this.goback();
        }
      },
      //展开酒店详情
      prewivethisRoom(item) {
        if (this.shareStatus) {
          location.href = "http://h5.shall-buy.com/share";
        } else {
          this.checkRoom(item, true);
        }
      },
      //酒店收藏
      hotelToCollection() {
        if (this.shareStatus) {
          location.href = "http://h5.shall-buy.com/share";
        } else {
          if (!this.clollectStatus) {
            hotelAddCollection(this.hotel_id).then((res) => {
              this.clollectStatus = true;
            });
          } else {
            hotelCancelCollection(this.hotel_id).then((res) => {
              this.clollectStatus = false;
            });
          }
        }
      },
      //酒店分享功能
      toShareHotel() {
        if (this.shareStatus) {
          location.href = "http://h5.shall-buy.com/share";
        } else {
          let title = "小巴酒店";
          let content = this.hotelinfo.chinese_name;
          let url = location.href;
          let hotel_id =
            this.hotel_id == "" ? this.$route.query.hotel_id : this.hotel_id;
          let shareurl =
            url.split("?")[0] +
            "?hotel_id=" +
            hotel_id +
            "&share=" +
            Date.parse(new Date());
          let android = [title, content, shareurl, this.sharelogo];
          let ios = [content, title, shareurl, this.sharelogo];
          this.params(JSON.stringify(ios), JSON.stringify(android), "toShare");
        }
      },
      //开启图片预览
      startPrewive(index) {
        this.previewshow = true;
        this.prewivewIndex = index;
      },
      //关闭图片预览
      closeImagePreview(data) {
        this.pupCurrent = data.index
        this.pupInitialswipe = data.index
        this.previewshow = false
      },
      //返回上一页
      goback() {
        if (this.$route.query.active) {
          this.$router.push({
            path: "/hotel/myOrder",
            hotel_detail: "hotel_detail",
            active: this.$route.query.active,
          });
        } else {
          this.$router.go(-1);
        }
      },
      //前往入住信息页面
      gocheckin(timeSelect = null) {
        if (this.shareStatus) {
          location.href = "http://h5.shall-buy.com/share";
        } else {
          this.$router.push({
            path: "/hotel/checkin",
            query: {
              timeSelect: timeSelect
            }
          });
        }
      },
      //前往酒店详细信息页面
      godetailinfo(actiavteNum) {
        if (this.shareStatus) {
          location.href = "http://h5.shall-buy.com/share";
        } else {
          this.hotelinfo.LowerPrice = this.recommendInfo.roomTypeNames ?
            this.recommendInfo.roomTypeNames[0].raisePrice :
            0;
          this.hoteldetail.detailActiavteNum = actiavteNum
          this.$router.push({
            path: "/hotel/detailinfo",
          });
        }
      },
      //前往酒店订单页面
      goconfirmorder(roominfo) {
        console.log('马上订')
        if (this.formConfirmorder) {
          this.closehotel();
          return;
        }
        if (this.shareStatus) {
          location.href = "http://h5.shall-buy.com/share";
        } else {
          if (this.ckeckinInfo.adultNum == 0) {
            Toast("请选择入住成人信息");
            return false;
          }
          this.checkRoom(roominfo).then((res) => {
            if (res.checkstatus) {
              roominfo.nowCoin = this.nowCoin;
              roominfo.images = this.images;
              roominfo = Object.assign(roominfo, res);
              this.setState([{
                name: "hoteldetail",
                value: {
                  hotelinfo: this.hotelinfo,
                  roominfo: roominfo,
                  canTakeTaxi: this.hoteldetail.canTakeTaxi
                },
              }]);
              this.$router.push({
                path: "/hotel/confirmorder",
                query: {
                  arrivalTimeFrom: res.arrivalTimeFrom,
                  arrivalTimeEnd: res.arrivalTimeEnd,
                  is_remark: this.is_remark,
                },
              });
            }
          });
        }
      },
      //前往酒店的地图位置
      goposition() {
        if (this.shareStatus) {
          location.href = "http://h5.shall-buy.com/share";
        } else {
          this.$router.push({
            path: "/hotel/position",
            query: {
              chinese_name: this.hotelinfo.chinese_name,
              latitude: this.hotelinfo.latitude,
              longitude: this.hotelinfo.longitude,
              distance: this.distance,
              business_district: this.hotelinfo.business_district,
              transport: this.transport,
              start_name: this.searchCity.name,
              end_name: this.hotelinfo.geo.City.Name,
            },
          });
        }
      },
      //查看其他推荐的酒店
      godetail(hotel_id) {
        let query = {
          hotel_id: hotel_id,
        }
        if (this.$route.query.share) {
          query.share = this.$route.query.share
        }
        this.$router.push({
          path: "/hotel/detail",
          query: query
        });
      },
      //前往图片预览页面
      golookimg() {
        if (this.shareStatus) {
          location.href = "http://h5.shall-buy.com/share";
        } else {
          let raisePrice = this.recommendInfo.roomTypeNames ?
            this.recommendInfo.roomTypeNames[0].raisePrice :
            0;
          this.$router.push({
            path: "/hotel/lookimg",
            query: {
              raisePrice: raisePrice,
              hotel_id: this.hotel_id,
            },
          });
        }
      },
    },
  };
</script>
<style lang='less'>
  html {
    font-size: calc(var(--sizeScale2) * 10px);
  }

  html,
  body {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
  }

  .datail-nav {
    .nav {
      .share-btn {
        img {
          width: 3.2rem !important;
          height: 3.2rem !important;
        }
      }
    }
  }
</style>
<style scoped lang='less'>
  html,
  body {
    overflow-x: hidden !important;
  }

  .detail-body {
    overflow-y: scroll;
    height: 100vh;
    -webkit-overflow-scrolling: touch;
  }

  .white-nav {
    position: relative;
    height: 3.5rem;
    padding: 0 2rem 0 2rem;

    .return-black,
    .collect-black,
    .share-black {
      display: inline-block;
      width: 1.5rem;
      height: 1.5rem;

      img {
        width: 100%;
        height: 100%;
        position: relative;
        top: 0.2rem;
      }
    }

    .return-black {
      vertical-align: top;
      margin-top: 1rem;

      img {
        width: 100%;
        height: 100%;
        position: relative;
        top: 0;
      }
    }

    .nav-room-name {
      display: inline-block;
      width: auto;
      height: 3.5rem;
      font-size: 1.5rem;
      font-weight: 500;
      color: #333333;
      line-height: 3.5rem;
      max-width: 23.9rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .collect-black {
      width: 2.4rem;
      height: 1.6rem;
      text-align: center;
      font-size: 0;
      position: absolute;
      right: 6.2rem;

      img {
        width: 1.6rem;
        height: 1.6rem;
        margin-bottom: 0.2rem;
      }
    }

    .share-black {
      width: 2.4rem;
      height: 1.6rem;
      text-align: center;
      font-size: 0;
      position: absolute;
      right: 2rem;

      img {
        width: 1.5rem;
        height: 1.5rem;
        margin-top: 0.1rem;
        margin-bottom: 0.2rem;
      }
    }

    .collect-text,
    .share-text {
      width: 2.6rem;
      height: 1.6rem;
      font-size: 1.1rem;
      font-weight: 400;
      color: #333333;
      line-height: 1.6rem;
    }

    .collect-text {
      width: 3.8rem;
      position: absolute;
      transform: translateX(-50%);
      margin-left: 50%;
    }
  }

  .booking-details {
    display: flex;
    padding: 0.5rem 2rem 1.3rem;
    text-align: center;

    .booking-btn,
    .book-details-btn {
      flex: 1;
      width: 6.4rem;
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 400;
      color: #999999;
      line-height: 2.2rem;
    }

    .booking-actiavte {
      flex: 1;
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 500;
      color: #333333;
      line-height: 2.2rem;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: 2.3rem;
        width: 3rem;
        height: 0.4rem;
        background: #108b30;
        border-radius: 0.2rem;
        left: 6.8rem;
      }
    }
  }

  .datail-nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding-top: 4.4rem;
    width: 100%;
    z-index: 5;
  }

  .swipe-top-index {
    position: absolute;
    right: 3rem;
    bottom: 5.6rem;
    width: 3.8rem;
    height: 1.9rem;
    font-size: 1.4rem;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 1rem;
    line-height: 1.9rem;
    text-align: center;
    color: #fff;
  }

  .pup-swipe-index {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 1rem;
    width: 3.8rem;
    height: 1.9rem;
    font-size: 1.4rem;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 1rem;
    line-height: 1.9rem;
    text-align: center;
    color: #fff;
  }

  .bg-div {
    width: 100%;
    height: 24rem;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .datail-left {
    position: relative;
    top: -5.6rem;

    .bg-two {
      height: 7.5rem;
      background: linear-gradient(360deg,
          #fbfbfb 0%,
          rgba(136, 135, 127, 0.8) 40%,
          rgba(68, 68, 68, 0) 100%);
    }

    .detail-info {
      position: relative;
      top: -5.9rem;
      margin: auto;
      width: calc(100% - 3rem);
      min-height: 17.7rem;
      background: #ffffff;
      box-shadow: 0rem 0.5rem 1rem 0rem rgba(19, 19, 19, 0.07);
      border-radius: 2rem;

      .hotel-detail-title {
        font-size: 1.6rem;
        font-weight: 600;
        color: #333333;
        line-height: 2.2rem;
        padding: 1.5rem 0 0.6rem 1.5rem;
      }

      .hotel-tag-div {
        display: flex;

        .static-tag {
          display: inline-block;
          height: 1.9rem;
          font-size: 1.2rem;
          font-weight: 400;
          color: #666666;
          line-height: 1.9rem;
          padding: 0 1rem 0 1.5rem;
          min-width: 3.6rem;
        }

        .more-color-tag {
          flex: 1;

          .static-tag-green,
          .static-tag-yellow,
          .static-tag-red,
          .static-tag-blue {
            display: inline-block;
            height: 1.4rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.4rem;
            color: #108b30;
            background: #ffffff;
            border-radius: 0.3rem;
            border: 0.1rem solid #108b30;
            margin-right: 0.5rem;
            margin-bottom: 0.5rem;
            padding: 0.1rem 0.2rem;
          }

          .static-tag-yellow {
            color: #f49103;
            border: 0.1rem solid #f49103;
          }

          .static-tag-red {
            color: #ff6253;
            border: 0.1rem solid #ff6253;
          }

          .static-tag-blue {
            color: #00a9ff;
            border: 0.1rem solid #00a9ff;
          }
        }
      }

      .three-div {
        padding: 0 0 0.3rem 0;

        .info-text {
          display: inline-block;
          height: 1.7rem;
          font-size: 1.2rem;
          font-weight: 400;
          color: #999999;
          line-height: 1.7rem;
          margin-right: 0.5rem;
        }

        .info-text:nth-child(1) {
          padding-left: 1.5rem;
        }

        .info-div-right {
          float: right;
          margin-right: 1.4rem;
          width: 8rem;

          .info-text {
            float: right;
            margin-right: 0;
          }

          .top-right-icon {
            height: 1.7rem;
            line-height: 1.7rem;
            float: right;

            span {
              width: 0.8rem;
              height: 0.8rem;
              display: inline-block;
              transform: translate(-50%, -50%);
              margin: 50% 0 0 50%;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }

      .four-div {
        padding: 0 1.5rem;
        display: flex;

        .detail-score {
          width: 2.9rem;
          height: 2.8rem;
          font-size: 2rem;
          font-weight: 600;
          color: #108b30;
          line-height: 2.8rem;
          padding: 0 1.1rem 0 0;
          display: inline-block;
          vertical-align: top;
        }

        .datail-description {
          flex: 1;
          display: inline-block;
          min-height: 2rem;
          font-size: 1.4rem;
          font-weight: 500;
          color: #333333;
          line-height: 2rem;
          vertical-align: top;
        }
      }

      .five-div {}

      .detail-address {
        min-height: 1.8rem;
        font-size: 1.3rem;
        font-weight: 400;
        color: #333333;
        line-height: 1.8rem;
        padding: 0.9rem 0 0.5rem 1.5rem;
        width: calc(100% - 5rem);
      }

      .detailed-distance {
        height: 1.7rem;
        font-size: 1.2rem;
        font-weight: 400;
        color: #666666;
        line-height: 1.7rem;
        padding: 0 0 0.5rem 1.5rem;
      }

      .detail-position {
        width: 1.6rem;
        height: 2.3rem;
        position: absolute;
        right: 1.5rem;
        bottom: 2.7rem;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .fixmargin-top {
    margin-top: -8.9rem;
  }

  .time-select-div {
    position: relative;
  }

  .time-select {
    background-color: #ffffff;
    z-index: 3;
    width: 100%;
    padding: 1.5rem 1.5rem 1rem;
    box-sizing: border-box;

    .static-enter {
      width: 1.3rem;
      height: 1.8rem;
      font-size: 1.3rem;
      font-weight: 400;
      color: #333333;
      line-height: 1.8rem;
      display: inline-block;
      margin: 0.4rem 0.5rem 0.3rem 0;
      vertical-align: top;
    }

    .day-div {
      display: inline-block;
      background: #108b30;
      border-radius: 0.8rem;
      min-width: 2rem;
      // line-height: 1.5;
      font-size: 1.1rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 1.6rem;
      padding: 0 0.6rem;
      margin-right: 0.6rem;
      position: relative;
      bottom: 0.2rem;
      white-space: nowrap;
    }

    .time-div,
    .adult-div,
    .child-black-div {
      display: inline-block;
      height: 2.5rem;
      font-size: 1.8rem;
      font-weight: 500;
      color: #333333;
      line-height: 2.5rem;
      margin-right: 0.6rem;
    }

    .time-con-right {
      position: absolute;
      right: 0;
      top: 0;
    }

    .adult-div {
      margin-right: 0.4rem;
      font-size: 1.6rem;
    }

    .child-black-div {
      margin-right: 0;
      font-size: 1.6rem;
    }

    .time-div:nth-child(1) {
      margin-right: 1.6rem;
      font-size: 1.4rem;
    }

    .child-div {
      display: inline-block;
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 500;
      color: #999999;
      line-height: 2.2rem;
    }

    .time-right-icon {
      display: inline-block;
      width: 1rem;
      height: 1rem;
      vertical-align: top;
      transform: translateY(60%);

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .room-div {
    padding: 1.5rem 0 0 0;

    .room-tag {
      display: inline-block;
      font-size: 1.4rem;
      font-weight: 400;
      color: #333333;
      line-height: 1.5;
      padding: 0.8rem 1rem;
      background: #eeeeee;
      border-radius: 0.5rem;
      margin-right: 1rem;
      text-align: center;
    }

    .room-tag-actiavte {
      background: #108b30;
      position: relative;
      color: #ffffff;

      .close-room-tag {
        position: absolute;
        right: -0.4rem;
        bottom: -0.4rem;
        width: 1.6rem;
        height: 1.6rem;

        img {
          width: 100%;
          height: 100%;
        }
      }

      // &::before {
      //   content: "x";
      //   position: absolute;
      //   right: -4rem;
      //   bottom: -4rem;
      //   width: 6rem;
      //   height: 6rem;
      //   padding: 5rem;
      //   line-height: 6rem;
      //   text-align: left;
      //   font-size: 4rem;
      //   background: rgba(255, 255, 255, 0.9);
      //   border-radius: 50%;
      //   color: #108b30;
      // }
      // .close-room-tag {
      //   position: absolute;
      //   right: -0.4rem;
      //   bottom: -0.4rem;
      //   width: 0.6rem;
      //   height: 0.6rem;
      //   padding: 0.3rem 0.5rem 0.5rem 0.3rem;
      //   line-height: 0.6rem;
      //   text-align: left;
      //   font-size: 1.3rem;
      //   background: rgba(255, 255, 255, 0.9);
      //   border-radius: 50%;
      //   color: #108b30;
      // }
    }
  }

  .recommend-room {
    // width: 34.5rem;
    height: 18.3rem;
    background: #ffffff;
    box-shadow: 0rem 0.5rem 1rem 0rem rgba(19, 19, 19, 0.07);
    border-radius: 2rem;
    margin: 1rem 1.5rem 0;
    padding-top: 1.5rem;

    .recommend-room-top {
      height: 5.4rem;

      .recommend-room-top-left {
        width: 7.9rem;
        height: 2.4rem;
        background: linear-gradient(135deg, #ff7742 0%, #ff5a4b 100%);
        border-radius: 0rem 0.4rem 0.4rem 0rem;
        display: inline-block;

        .recommend-icon {
          display: inline-block;
          width: 1.6rem;
          height: 1.5rem;
          padding: 0.5rem 0.5rem 0.4rem 0.5rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .recommend-text {
          display: inline-block;
          height: 1.7rem;
          font-size: 1.2rem;
          font-weight: 500;
          color: #ffffff;
          line-height: 1.7rem;
          padding: 0.4rem 0 0.4rem 0;
          vertical-align: top;
        }
      }

      .recommend-room-top-right {
        height: 1.7rem;
        font-size: 1.2rem;
        font-weight: 400;
        color: #999999;
        line-height: 1.7rem;
        float: right;
        margin-right: 1.5rem;
        margin-top: 0.5rem;
      }
    }
  }

  .recommend-bottom {
    position: relative;
    display: flex;
    min-height: 12.9rem;

    .bottom-left {
      width: 9rem;
      height: 9rem;
      margin: 0 0.8rem 0 1.5rem;
      border-radius: 1rem;
      overflow: hidden;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }

      .left-img-num {
        background: rgba(0, 0, 0, 0.5);
        border-radius: 1rem;
        position: absolute;
        right: 1rem;
        bottom: 1rem;
        font-size: 1rem;
        font-weight: 400;
        color: #FFFFFF;
        height: 1.4rem;
        line-height: 1.4rem;
        padding: 0.1rem 0.7rem;
        text-align: center;
      }
    }

    .bottom-right {
      flex: 1;
      max-width: calc(100% - 11rem);

      .bottom-right-title {
        width: 100%;
        padding-top: 0.5rem;
      }

      .second-div {
        width: 100%;
        position: relative;
        padding: 0.5rem 0;
      }
    }
  }

  .static-recommend-bottom {
    min-height: auto;
    position: relative;
  }

  .room-static-div {
    background: #fbfbfb;

    .room-static {
      padding-top: 2rem;

      &:nth-last-of-type(3) {
        .recommend-bottom {
          padding-bottom: 2rem;
        }

        .three-tag-green {
          margin-bottom: 2rem;
        }
      }
    }


    .room-static-bottom,
    .room-static-up-bottom {
      padding: 0 0 2rem;
      margin: auto;
      text-align: center;
      height: 1.8rem;
      font-size: 1.3rem;
      font-weight: 400;
      color: #333333;
      line-height: 1.8rem;

      .room-static-bottom-open-img {
        height: 100%;
        margin-top: 0.4rem;
        vertical-align: top;

        img {
          display: inline-block;
          vertical-align: top;
          width: 0.8rem;
          height: 0.8rem;
          margin-top: 0.4rem;
        }
      }
    }

    .room-static-up-bottom {
      .room-static-up-bottom-img {
        height: 100%;
        vertical-align: top;

        img {
          vertical-align: top;
          margin-top: 0.5rem;
          position: relative;
          left: 0.2rem;
          width: 0.8rem;
          height: 0.8rem;
          transform: rotate(180deg);
        }
      }
    }
  }

  // 房间通用样式
  .romm-type {
    display: inline-block;
    height: 2.2rem;
    font-size: 1.6rem;
    font-weight: 500;
    color: #333333;
    line-height: 2.2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 65%;
    white-space: nowrap;
  }

  .static-room-title {
    padding: 2.2rem 0 0 0 !important;
  }

  .recommend-room-price {
    float: right;
    margin-right: 1.5rem;
  }

  .room-price {
    .room-price-red {
      display: inline-block;
      height: 3.3rem;
      min-width: 4.1rem;
      text-align: right;

      span {
        font-size: 1.2rem;
        font-weight: 400;
        color: #f84737;
        line-height: 1.7rem;
      }

      .room-price-number {
        font-size: 2rem;
        font-weight: 500;
      }
    }

    .room-price-text {
      width: 1.8rem;
      height: 1.7rem;
      font-size: 1.2rem;
      font-weight: 400;
      color: #999999;
      line-height: 1.7rem;
      display: inline-block;
    }

    .room-price-text-img {
      width: 2.1rem;

      img {
        width: 0.8rem;
        height: 0.8rem;
      }
    }
  }

  .price-integral-div-room {
    position: absolute;
    top: 2.5rem;
    right: 1.5rem;

    .room-price-div {
      text-align: right;
      padding-bottom: 0.5rem;

      .room-price-red {
        display: inline-block;
        min-width: 4.1rem;

        span {
          font-size: 1.2rem;
          font-weight: 400;
          color: #f84737;
          line-height: 1.7rem;
        }

        .room-price-number {
          font-size: 2rem;
          font-weight: 500;
        }
      }

      .room-price-text-img {
        height: 1.7rem;
        font-size: 1.2rem;
        font-weight: 400;
        color: #999999;
        line-height: 1.7rem;
        width: 2.1rem;
        float: right;

        img {
          width: 0.8rem;
          height: 0.8rem;
        }
      }
    }

    .integral-div {
      display: inline-block;
      right: 1.5rem;
      height: 1.8rem;
      font-size: 1.3rem;
      font-weight: 400;
      color: #f9591b;
      line-height: 1.8rem;
    }
  }

  .second-text,
  .second-text-text {
    display: inline-block;
    height: 2rem;
    font-size: 1.4rem;
    font-weight: 400;
    color: #666666;
    line-height: 2rem;
    margin: 0.5rem 0;
  }

  .second-text-text {
    font-size: 1.2rem;
    height: 1.7rem;
    line-height: 1.7rem;
  }

  .second-right {
    position: absolute;
    top: 0.6rem;
    display: inline-block;
    right: 1.5rem;
    height: 1.8rem;
    font-size: 1.3rem;
    font-weight: 400;
    color: #f9591b;
    line-height: 1.8rem;
  }

  .three-tag-green,
  .three-tag-static {
    display: inline-block;
    height: 1.7rem;
    font-size: 1.2rem;
    font-weight: 400;
    color: #108b30;
    line-height: 1.7rem;
    margin-right: 0.5rem;
  }

  .three-tag-static {
    color: #999999;
  }

  .four-btn {
    position: absolute;
    right: 1.5rem;
    bottom: 1.5rem;
    width: 6.8rem;
    height: 4.5rem;
    background: linear-gradient(135deg, #ff7742 0%, #ff5a4b 100%);
    border-radius: 1rem;
    text-align: center;

    .four-big-text {
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 2.2rem;
      margin: auto;
      padding: 0.2rem 0 0 0;
    }

    .four-static-text {
      height: 1.7rem;
      font-size: 1.2rem;
      font-weight: 400;
      color: #ffffff;
      line-height: 1.7rem;
      margin: auto;
    }
  }

  .no-this-room {
    position: absolute;
    right: 1.5rem;
    bottom: 1.5rem;

    img {
      width: 8.2rem;
      height: 5.7rem;
    }
  }

  // 房间通用样式结束
  .isiOSX {
    .van-nav-bar {
      padding-top: 4.4rem;
    }

    .reback {
      top: 4.9rem;
    }
  }

  .room-open {
    padding: 2rem 1.5rem 0;
    position: relative;

    .no-this-room {
      bottom: 0;
    }

    .room-open-title {
      height: 2.2rem;

      img {
        width: 2.2rem;
        height: 2.2rem;
      }
    }

    span {
      width: 2.6rem;
      height: 1.8rem;
      font-size: 1.3rem;
      font-weight: 400;
      color: #666666;
      line-height: 1.8rem;
      position: relative;
      top: -0.5rem;
      left: 0.5rem;
    }

    .room-price-integral {
      position: absolute;
      right: 7.2rem;
      bottom: 1.5rem;
      width: 10.5rem;
      height: 3.8rem;

      .room-price-integral-div {
        display: inline-block;

        .room-price-red {
          display: inline-block;
          min-width: 6.9rem;
          position: relative;
          bottom: -0.5rem;
          text-align: right;
          margin-right: 0.5rem;

          span {
            font-size: 1.2rem;
            font-weight: 400;
            color: #f84737;
            line-height: 1.7rem;
          }

          .room-price-number {
            font-size: 2rem;
            font-weight: 500;
          }
        }

        .room-price-text,
        .room-price-text-img {
          display: inline-block;
          width: 1.8rem;
          height: 1.7rem;
          font-size: 1.2rem;
          font-weight: 400;
          color: #999999;
          line-height: 1.7rem;
        }

        .room-price-text-img {
          width: 2.1rem;

          img {
            width: 0.8rem;
            height: 0.8rem;
          }
        }
      }

      .second-right {
        position: absolute;
        top: 2.1rem;
        display: inline-block;
        right: 1.5rem;
        height: 1.8rem;
        font-size: 1.3rem;
        font-weight: 400;
        color: #f9591b;
        line-height: 1.8rem;
      }
    }
  }

  .room-close-btn-right {
    position: absolute;
    right: 1.5rem;
    top: 2.3rem;

    .room-close-price-text-img {
      display: inline-block;
      width: 1.8rem;
      height: 1.7rem;
      font-size: 1.2rem;
      font-weight: 400;
      color: #999999;
      line-height: 1.7rem;
      width: 3.3rem;

      img {
        width: 0.8rem;
        height: 0.8rem;
      }
    }
  }

  .datail-bottom {
    padding: 2rem 1.5rem 0;

    .room-read {
      height: 2.5rem;
      font-size: 1.8rem;
      font-weight: 500;
      color: #333333;
      line-height: 2.5rem;
      position: relative;

      img {
        width: 2rem;
        height: 2rem;
        position: relative;
        top: 0.2rem;
        margin-right: 0.5rem;
      }
    }

    .read-text {
      height: 2.1rem;
      font-size: 1.5rem;
      font-weight: 400;
      color: #333333;
      line-height: 2.1rem;
    }

    .second-read {
      padding: 0.5rem 0 0rem 2rem;
      word-break: break-word;
      height: auto;
      line-height: 2.6rem;
    }

    .deail-right-text {
      position: absolute;
      top: 0.4rem;
      right: 0;
      height: 1.7rem;
      font-size: 1.2rem;
      font-weight: 400;
      color: #666666;
      line-height: 1.7rem;

      .deail-right-text-img {
        height: 1.7rem;
        vertical-align: top;
        display: inline-block;
        line-height: 1.7rem;

        img {
          vertical-align: top;
          width: 0.8rem;
          height: 0.8rem;
          margin-top: 0.3rem;
        }
      }
    }
  }

  .check-in-out {
    display: flex;

    div {
      flex: 1;
      padding: 2rem 0 3rem 0;

      div:nth-of-type(1) {
        height: 2rem;
        font-size: 1.4rem;
        font-weight: 400;
        color: #999999;
        line-height: 2rem;
        padding: 0 0 0 0;
      }

      div:nth-of-type(2) {
        padding: 0.5rem 0 0 0;
        height: 2rem;
        font-size: 1.4rem;
        font-weight: 400;
        color: #333333;
        line-height: 2rem;
      }
    }
  }

  .room-detail-bottom-read-div {
    display: flex;

    div {
      flex: 1;

      .read-div-text {
        padding: 1rem 0 0 0;
        height: 2rem;
        font-size: 1.4rem;
        font-weight: 400;
        color: #333333;
        line-height: 2rem;
      }
    }
  }

  .may-like {
    padding: 3rem 0 0 0;
  }

  .may-list-product-list {
    padding-bottom: 6rem;

    .product {
      padding-right: 0;
      padding-left: 0;
    }
  }

  .no-hotel-find {
    width: 100%;

    .no-find-text {
      text-align: center;
      margin: auto;
      padding-bottom: 2rem;
      width: 20rem;
      height: 4.8rem;
      font-size: 1.4rem;
      font-weight: 400;
      color: #333333;
      line-height: 2.4rem;
    }

    img {
      width: 15.1rem;
      height: 13.8rem;
      margin: 0 auto;
      display: block;
    }
  }

  .suggest-div {
    background: #ecf6ef;
    width: calc(100% -1.5rem);
    height: 2rem;
    font-size: 1.4rem;
    font-weight: 400;
    color: #108b30;
    line-height: 2rem;
    padding: 1rem 0 1rem 1.5rem;
  }

  .no-room-text {
    >div {
      color: #cccccc !important;
    }
  }

  .detail-pup {
    padding: 1.9rem 1.5rem 0;
    overflow: hidden;

    .hotel-pup-content {
      height: calc(80vh - 12rem);
      overflow-y: scroll;
      scrollbar-width: none;
      /* firefox */
      -ms-overflow-style: none;

      /* IE 10+ */
      &::-webkit-scrollbar {
        display: none;
        /* Chrome Safari */
      }
    }

    .detail-swipe-div {
      height: 18rem;
      overflow: hidden;
      border-radius: 2rem;

      img {
        width: 100%;
      }
    }

    .first-title,
    .second-title,
    .three-title,
    .four-title {
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 500;
      color: #333333;
      line-height: 2.2rem;
    }

    .first-title {
      padding-bottom: 2rem;
    }

    .second-title {
      font-size: 1.8rem;
      padding: 2rem 0 1rem 0;
    }

    .three-title {
      font-size: 1.5rem;
      padding: 2rem 0 1rem 0;
    }

    .tip-text {
      font-size: 1.3rem;
      font-weight: 400;
      color: #666666;
      line-height: 2.3rem;
    }

    .tip-text:last-child {
      padding-bottom: 6rem;
    }

    .food-tip {
      width: 15.7rem;
      height: 2rem;
      font-size: 1.4rem;
      font-weight: 400;
      color: #333333;
      line-height: 2rem;
    }

    .pup-second-text {
      height: 1.7rem;
      font-size: 1.2rem;
      font-weight: 400;
      color: #333333;
      line-height: 1.7rem;
      padding-bottom: 1rem;
    }

    .pup-datail-facilitys {
      display: flex;

      .facilitys-div {
        flex: 1;

        div {
          height: 1.7rem;
          font-size: 1.2rem;
          font-weight: 400;
          color: #666666;
          line-height: 1.7rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 1rem;

          &:last-child {
            margin-bottom: 0;
          }

          img {
            width: 0.8rem;
            height: 0.8rem;
          }
        }
      }
    }
  }

  .pup-datail-bottom {
    background: #ffffff;
    box-shadow: 0rem -0.5rem 1rem 0rem rgba(19, 19, 19, 0.1);
    height: 5.7rem;
    position: fixed;
    bottom: 0;
    width: 100%;

    .pup-datail-price {
      display: inline-block;
      height: 5.7rem;
      line-height: 5.7rem;
      padding-left: 1.5rem;
    }

    .pup-booking-btn {
      float: right;
      margin: 0.6rem 1.5rem 0 0;
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 2.2rem;
      padding: 1.2rem 4.7rem 1.1rem 4.7rem;
      background: linear-gradient(135deg, #ff7742 0%, #ff5a4b 100%);
      border-radius: 2.3rem;
    }
  }

  .leftback {
    animation: leftback 0.4s cubic-bezier(0.88, 0.23, 0.81, 0.87) 1 normal;
  }

  @keyframes leftback {
    0% {
      transform: translateX(100%);
      opacity: 0;
    }

    25% {
      transform: translateX(75%);
      opacity: 0.2;
    }

    50% {
      transform: translateX(50%);
      opacity: 0.4;
    }

    75% {
      transform: translateX(25%);
      opacity: 0.6;
    }

    90% {
      transform: translateX(10%);
      opacity: 0.8;
    }

    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .pop-position {
    width: 31.5rem;
    height: 19.9rem;
    background-color: #fff;
    border-radius: 2rem;
    padding: 2rem;
    box-sizing: border-box;

    h3 {
      margin: 0;
      font-size: 1.8rem;
      font-weight: 500;
      color: #181818;
      line-height: 2.5rem;
      text-align: center;
      margin-bottom: 1.8rem;
    }

    p {
      font-size: 1.6rem;
      font-weight: 400;
      color: #333333;
      line-height: 2.8rem;
      margin-bottom: 3rem;
      text-align: center;
    }

    >div {
      display: flex;
      justify-content: space-between;

      div {
        height: 5rem;
        background-color: #108B30;
        border-radius: 1rem;
        font-size: 1.8rem;
        line-height: 5rem;
        padding:  0 2.5rem;
        color: #fff;
        text-align: center;
        margin: auto;
        &.active {
          background-color: #108B30;
          color: #fff;
        }
      }
    }
  }
</style>